// The chip on a Finance merchant line. Green "Receipt · 1 of 1" when any
// charge on the line holds a receipt (one tap opens it; several open a short
// list); a quiet dashed "no receipt · n" on a FIG line whose charges have
// none; nothing otherwise. Built only from the rows the page already loaded.
import { useState } from 'react';
import { receiptCountsForLine, figNoReceiptCount, chipText } from './receiptChips';
import { usd, shortDate } from './money';
import './Receipts.css';

export default function ReceiptChip({ txs, categoryName, onOpen }) {
  const [open, setOpen] = useState(false);
  const counts = receiptCountsForLine(txs);
  if (counts.withReceipt === 0) {
    const n = figNoReceiptCount(txs, categoryName);
    return n > 0 ? <span className="rc-chip rc-chip--none" title="FIG charges on this line with no receipt">no receipt · {n}</span> : null;
  }
  const click = (e) => {
    e.stopPropagation();
    if (counts.refs.length === 1) onOpen(counts.refs[0]);
    else setOpen((o) => !o);
  };
  const withRef = txs.filter((t) => typeof t.ReceiptRef === 'string' && t.ReceiptRef.trim());
  return (
    <span className="rc-chip-wrap">
      <button type="button" className="rc-chip rc-chip--ok" onClick={click} aria-haspopup={counts.refs.length > 1}>✓ {chipText(counts)}</button>
      {open && (
        <span className="rc-pop" role="menu" onMouseLeave={() => setOpen(false)}>
          {withRef.map((t) => (
            <button key={`${t.id}-${t.ReceiptRef}`} type="button" role="menuitem" onClick={(e) => { e.stopPropagation(); setOpen(false); onOpen(t.ReceiptRef.trim()); }}>
              <span>{shortDate(String(t.Date || '').slice(0, 10))} · {t.ReceiptRef.trim()}</span><strong>{usd(t.Amount)}</strong>
            </button>
          ))}
        </span>
      )}
    </span>
  );
}
